<template>
  <div class="modal-content">
    <button type="button" class="close" @click="$emit('closeModal')">
      <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17"></svg></span>
    </button>
    <div class="modal-body d-flex flex-column align-items-center">
      <svg v-svg symbol="success-full-green" width="42px" height="42px"></svg>

      <h3>{{ $t("domain.buy_domain_modal.ready") }}</h3>
      <p>{{ $t("domain.buy_domain_modal.success") }}</p>

      <button class="btn _mob100" @click="$emit('closeModal')">Ок</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessBuyDomain",
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 70px 40px;

  h3 {
    font-size: 28px;
    font-weight: 700;
    margin-top: 30px;
  }

  button {
    margin-top: 30px;
  }
}
</style>
